<template>
    <div class="inner-title" @click="handleClick">
        <span class="sp1" :class="icon" v-show="icon" />
        <span class="sp2" v-show="text">{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: 'InnerTitle',
    props: {
        text: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
        handleClick() {
            this.$emit('click')
        },
    },
}
</script>

<style lang="scss" scoped>
.inner-title {
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    span {
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.sp1 {
            width: 16px;
            height: 16px;

            &.history {
                background-image: url(@/assets/images/common/title/history.svg);
            }

            &.history2 {
                background-image: url(@/assets/images/common/title/history2.svg);
            }

            &.aiChat {
                background-image: url(@/assets/images/common/title/aiChat.svg);
            }

            &.aiWrite {
                background-image: url(@/assets/images/common/title/aiWrite.svg);
            }

            &.aiSearch {
                background-image: url(@/assets/images/common/title/aiSearch.svg);
            }

            &.aiTranslate {
                background-image: url(@/assets/images/common/title/aiTranslate.svg);
            }

            &.customAdd {
                background-image: url(@/assets/images/common/title/customAdd.svg);
            }
        }

        &.sp2 {
            font-size: 14px;
            margin: 0 0 0 6px;
            color: #615e83;
        }
    }
}
</style>